__turbopack_context__.v({
  "content": "Header-module__KZsWCG__content",
  "findOut": "Header-module__KZsWCG__findOut",
  "header": "Header-module__KZsWCG__header",
  "headerContainer": "Header-module__KZsWCG__headerContainer",
  "link": "Header-module__KZsWCG__link",
  "product": "Header-module__KZsWCG__product",
  "products": "Header-module__KZsWCG__products",
});
